// Global stylesheet
import { createGlobalStyle } from "styled-components"

// Styling
import colors from "./colors"
import textStyles from "./textStyles"
import { fontFaces } from "./fonts"

const GlobalStyle = createGlobalStyle`
  ${fontFaces};

  ::-moz-selection {
    background-color: rgba(250, 70, 22, 0.99);
    color: ${colors.black};
  }

  ::selection {
    background-color: rgba(250, 70, 22, 0.99);
    color: ${colors.black};
  }

  html,
  body {
    width: 100%;
    height: 100%;
    ${textStyles.body};
    margin: 0;
    color: ${colors.black};
    background-color: ${colors.white};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body {
    -webkit-tap-highlight-color: transparent;
  }

  p {
    ${textStyles.body};
  }
`

export default GlobalStyle
